"use client";

import { VWOScript } from "vwo-smartcode-nextjs";

export const ABTestingScript = () => {
    return <VWOScript accountId="914011" />;
};
